import React from 'react'

const Hero = () => {
    return (
        <section
            className="relative h-[60vh] md:h-[80vh] hero-container py-16 md:py-40 flex items-center px-4"
        >
            {/* ----------------------------------------- Overlay  */}
            <div className='bg-black/70 absolute inset-0'></div>

            {/*----------------------------------------- Content Box  */}
            <div className='max-w-7xl w-full m-auto relative'>
                <h2 className="text-2xl md:text-4xl font-bold text-white">
                    Fast. Reliable. <br />
                    Commercial deliveries in 2 hours.
                </h2>

                <p className='text-white text-sm md:text-xl lg:max-w-[500px] w-full mt-2'>Australia’s first dedicated trade, construction, and commercial delivery service.</p>
            </div>
        </section>
    )
}

export default Hero